import { Route, Routes } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { RequireAuth, RequireRole } from "@/components/RequireAuth";
import { LoginPage } from "@/pages/LoginPage";
import { ForgotPasswordPage } from "@/pages/ForgotPasswordPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";
import { RegisterProviderPage } from "@/pages/RegisterProviderPage";
import { RegisterRefereePage } from "@/pages/RegisterRefereePage";
import { DashboardPage } from "@/pages/DashboardPage";
import { ClubsPage } from "@/pages/ClubsPage";
import { ClubDetailPage } from "@/pages/ClubDetailPage";
import { ClubCreatePage } from "@/pages/ClubCreatePage";
import { CourtDetailPage } from "@/pages/CourtDetailPage";
import { ProvidersPage } from "@/pages/ProvidersPage";
import { ProviderDetailPage } from "@/pages/ProviderDetailPage";
import { UsersPage } from "@/pages/UsersPage";
import { ReservationsPage } from "@/pages/ReservationsPage";
import { LiveMatchesPage } from "@/pages/LiveMatchesPage";
import { PartidosPage } from "@/pages/PartidosPage";
import { MatchDetailPage } from "@/pages/MatchDetailPage";
import { PlayersPage } from "@/pages/PlayersPage";
import { ProfilePage } from "@/pages/ProfilePage";
import { ForbiddenPage } from "@/pages/ForbiddenPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { DeviceViewPage } from "@/pages/DeviceViewPage";
import { RefereePage } from "@/pages/RefereePage";
import { AuditoriaPage } from "@/pages/AuditoriaPage";
import { RefereesPage } from "@/pages/RefereesPage";
import { RefereeHomePage } from "@/pages/RefereeHomePage";
import { ChampionshipsPage } from "@/pages/ChampionshipsPage";
import { ChampionshipCreatePage } from "@/pages/ChampionshipCreatePage";
import { ChampionshipDetailPage } from "@/pages/ChampionshipDetailPage";
import { ChampionshipTeamPage } from "@/pages/ChampionshipTeamPage";
import { useAuthStore } from "@/store/auth";

// Los árbitros con cuenta de panel solo tienen su propia página de inicio (sus partidos asignados).
function HomePage() {
  const role = useAuthStore((s) => s.user?.role);
  return role === "REFEREE" ? <RefereeHomePage /> : <DashboardPage />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/olvide-mi-contrasena" element={<ForgotPasswordPage />} />
      <Route path="/restablecer-contrasena" element={<ResetPasswordPage />} />
      <Route path="/registro" element={<RegisterProviderPage />} />
      <Route path="/registro-arbitro" element={<RegisterRefereePage />} />
      <Route path="/403" element={<ForbiddenPage />} />
      <Route path="/pista/:token" element={<DeviceViewPage />} />
      <Route path="/arbitro" element={<RefereePage />} />
      <Route path="/arbitro/:code" element={<RefereePage />} />

      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/perfil" element={<ProfilePage />} />

          <Route element={<RequireRole roles={["SUPER_ADMIN", "PROVIDER", "CLUB"]} />}>
            <Route path="/reservas" element={<ReservationsPage />} />
            <Route path="/partidos-en-directo" element={<LiveMatchesPage />} />
            <Route path="/partidos" element={<PartidosPage />} />
            <Route path="/partidos/:id" element={<MatchDetailPage />} />
            <Route path="/jugadores" element={<PlayersPage />} />
            <Route path="/usuarios" element={<UsersPage />} />
            <Route path="/auditoria" element={<AuditoriaPage />} />
            <Route path="/campeonatos" element={<ChampionshipsPage />} />
            <Route path="/campeonatos/:id" element={<ChampionshipDetailPage />} />
            <Route path="/campeonatos/:id/equipos/:equipoId" element={<ChampionshipTeamPage />} />
          </Route>

          <Route element={<RequireRole roles={["SUPER_ADMIN", "PROVIDER"]} />}>
            <Route path="/campeonatos/nuevo" element={<ChampionshipCreatePage />} />
          </Route>

          <Route element={<RequireRole roles={["SUPER_ADMIN", "PROVIDER"]} />}>
            <Route path="/clubes" element={<ClubsPage />} />
            <Route path="/clubes/nuevo" element={<ClubCreatePage />} />
            <Route path="/clubes/:id" element={<ClubDetailPage />} />
            <Route path="/clubes/:clubId/pistas/:courtId" element={<CourtDetailPage />} />
          </Route>

          <Route element={<RequireRole roles={["SUPER_ADMIN"]} />}>
            <Route path="/proveedores" element={<ProvidersPage />} />
            <Route path="/proveedores/:id" element={<ProviderDetailPage />} />
            <Route path="/arbitros" element={<RefereesPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
